<template>
	<div class="finish-delivery-container">
		<div class="finish-delivery-content">
			<div class="header-finish-delivery">
				<h4>Confirmar servicio</h4>
			</div>
			<div class="client-delivery-info">
				<div class="header-titlle-info">
					<h4>Datos personales</h4>
				</div>
				<div class="info-client-detail">
					<div class="client-info mt">
						<div class="client-icon-container">
							<i class="fas fa-user"></i>
						</div>
						<div class="client-info-container">
							<h5>Nombres:</h5>
							<h4>{{ user_name }}</h4>
						</div>						
					</div>
					<div class="client-info">
						<div class="client-icon-container">
							<i class="fas fa-phone-alt"></i>
						</div>
						<div class="client-info-container">
							<h5>Teléfono:</h5>
							<h4>{{ user_phone }}</h4>
						</div>
					</div>
				</div>
			</div>
			<div class="detail-service-container">
				<div class="header-titlle-info">
					<h4>Detalle</h4>
				</div>
				<div class="info-client-detail">
					<div class="client-info mt">
						<div class="client-icon-container">
							<i class="fas fa-map-pin"></i>
						</div>
						<div class="client-info-container">
							<h5>Dirección de origen:</h5>
							<h4>{{ form.origin_address }}</h4>
						</div>
					</div>
					<div class="client-info">
						<div class="client-icon-container">
							<i class="fas fa-map-pin"></i>
						</div>
						<div class="client-info-container">
							<h5>Destino:</h5>
							<h4>{{ form.destiny_address }}</h4>
						</div>
					</div>
				</div>
			</div>
			<div class="checkout-details">
				<div class="single-item-checkout pt">
					<h4>Distancia:</h4>
					<h5>{{distance}}km</h5>
				</div>
				<hr>
				<div class="single-item-checkout">
					<h4>Tarifa:</h4>
					<h5>${{Intl.NumberFormat("de-DE").format(valor_domicilio)}}</h5>
				</div>
				<hr>
				<div class="single-item-checkout" v-if="status">
					<h4>Recargo por distancia:</h4>
					<h5>$1.000</h5>
				</div>
				<hr v-if="status">
				<div class="single-item-checkout">
					<h4>Total:</h4>
					<h5>${{Intl.NumberFormat("de-DE").format(valor_domicilio)}}</h5>
				</div>
			</div>
			<div class="finisih-order-container">
				<button class="btn-cancelar" @click="cancel()">Cancelar</button>
				<button class="btn-confirmar" @click="saveBD()">Confirmar</button>
			</div>
		</div>
	</div>
</template>

<style>
	
	@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

		*:focus{
			outline: none !important;
		}

		.finisih-order-container{
			width: 90%;
			margin: 0 auto;
			height: 100%;
			padding-top: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.btn-cancelar{
			width: 48%;
			background: transparent;
			color: #3A3A3A;
			padding: 10px;
			border: 1px solid #EDEDED;
			border-radius: 8px;
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			font-size: 16px;
		}

		.btn-confirmar{
			width: 48%;
			border: none;
			background: #0E115D;
			color: #fff;
			padding: 10px;
			border-radius: 8px;
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			font-size: 16px;
		}

		.pt{
			padding-top: 20px;
		}

		.checkout-details{
			width: 90%;
			margin: 0 auto;
		}

		.checkout-details hr{
			width: 100%;
			border-top: 1px dotted #000;
			margin-top: 5px;
		}

		.single-item-checkout{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.single-item-checkout h4{
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			font-size: 14px;
			color: #3A3A3A;
			margin-bottom: 0;
		}

		.single-item-checkout h5{
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			font-size: 14px;
			color: #000;
			margin-bottom: 0;
		}

		.detail-service-container{
			width: 90%;
			margin: 0 auto;
			background: #fff;	
			border-radius: 10px;
			box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
		}

		.client-icon-container{
			width: 45px;
			height: 45px;
			border-radius: 50%;
			display: flex;
			justify-content: center;
			align-items: center;
			background: #ECECF9;
		}

		.client-icon-container i{
			color: #0E115D;
			font-size: 15px;
		}

		.client-info-container{
			padding: 0px 10px;
			text-align: left;
		}

		.client-info-container h5{
			font-family: 'Poppins', sans-serif;
			font-weight: 600;
			font-size: 12px;
			color: #3A3A3A;
			margin-bottom: 3px;
		}

		.client-info-container h4{
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			font-size: 13px;
			color: #3A3A3A;
			margin-bottom: 0;
		}

		.finish-delivery-container{
			width: 100%;
			height: auto;
			background: #fff;
		}

		.finish-delivery-content{
			width: 100%;
			height: auto;
			/*padding: 10px 15px;*/
		}

		.header-finish-delivery{
			background: #0E115D;
			height: 25vh;
			text-align: center;
			padding-top: 20px;
		}

		.header-finish-delivery h4{
			font-family: 'Poppins', sans-serif;
			font-weight: 500;
			font-size: 19px;
			color: #fff;
			margin-bottom: 0;
		}

		.client-delivery-info{
			width: 90%;
			margin: 0 auto;
			background: #fff;
			border-radius: 10px;
			box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
			margin-top: -100px;
			margin-bottom: 20px;
		}

		.header-titlle-info{
			width: 100%;
			padding: 13px 20px;
			border-bottom: 1px solid #EBEBEB;
		}

		.header-titlle-info h4{
			font-family: 'Poppins', sans-serif;
			font-weight: 600;
			font-size: 14px;
			color: #3A3A3A;
			margin-bottom: 0;
		}

		.info-client-detail{
			width: 100%;
			display: block;
			padding: 15px 20px;
		}

		.client-info{
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.mt{
			margin-bottom: 10px;
		}
</style>

<script>
	import axios from 'axios';
	import { osName } from 'mobile-device-detect';
	export default{
		props: ['form'],
		data(){
			return{
				nameOS: osName,
				status: false,
				user_name: localStorage.getItem('delivery_user'),
				user_phone: localStorage.getItem('delivery_phone'),
				longitud_delivery: localStorage.getItem('longitud_delivery'),
				latitud_delivery: localStorage.getItem('latitud_delivery'),
				distance: 0,
				companie_id: localStorage.getItem('companie_id'),
				id_point: localStorage.getItem('id_point'),
				valor_domicilio: 0,
				mensaje: '',
				telefono_pedidos: localStorage.getItem('telefono_pedidos')
			}
		},
		methods:{
			cancel(){
				this.$emit('closeFinish',false);
			},
			managmentTaxes(listado){
				var self=this
				let puntero=false
				let puntero2=false
				this.valor_domicilio=0;
				listado.forEach((item) => {
					if (parseFloat(this.distance) > parseFloat(item.initial_range) && parseFloat(this.distance) < parseFloat(item.end_range)) {
						this.valor_domicilio = parseInt(item.value);
					}
				});
				if (this.valor_domicilio==0) {
				    listado.forEach((item) => {
	                    if (parseFloat(item.initial_range)>=parseFloat(self.distance)  && parseFloat(item.initial_range)>=parseFloat(self.distance) && !puntero) {
	                       self.valor_domicilio = parseInt(item.value);
	                       puntero=true;
	                    }
	                    if ( parseFloat(item.initial_range)<=parseFloat(self.distance)  && parseFloat(item.initial_range)<=parseFloat(self.distance) && !puntero ){
	                      self.valor_domicilio = parseInt(item.value);
	                    }
					});
				}
			},
			getListTaxes(){
				var self = this;
				axios
		        .get('https://admin.vinapp.co/api/get-list-tarifas-envio/'+this.companie_id)
		        .then((res) => {
			        console.log(res.data);
			        let taxes_list = res.data;
			        self.managmentTaxes(taxes_list);
			    })
			    .catch((err) => {
			      console.log(err);
			    });
			},
			sendWhatsApp(){
				//construimos el mensaje para wapp
      			//se agregan los espacios al nombre de la empresa
      			this.mensaje = '';
      			let nombre_comercial = localStorage.getItem('nombre_comercial');
      			nombre_comercial = nombre_comercial.replace(" ","%20");
      			let nombre = this.user_name.replace(" ","%20");
      			this.mensaje += `
			    https://wa.me/${this.telefono_pedidos}?text=Hola%20${nombre_comercial}%20soy%20*${nombre.trim()}*%20me%20gustaria%20${this.form.service}.`;
			    //le damos formato a ambas direcciones
			    let direccion1 = this.form.origin_address;
			    let direccion_pedido = '';
			    direccion1 = direccion1.replace("#",'%23');
			    direccion1 = direccion1.split(' ');
			    let tamaño = direccion1.length;
		        direccion1.forEach((parte,index)=>{
		            index += 1;
		            if(index < tamaño){
		              direccion_pedido += `${parte}%20`
		            }else{
		              direccion_pedido += `${parte}`
		            }
		        });
		        let direccion2 = this.form.destiny_address;
		        let direccion_destino = '';
		        direccion2 = direccion2.replace("#",'%23');
			    direccion2 = direccion2.split(' ');
			    let tamaño2 = direccion2.length;
		        direccion2.forEach((parte,index)=>{
		            index += 1;
		            if(index < tamaño2){
		              direccion_destino += `${parte}%20`
		            }else{
		              direccion_destino += `${parte}`
		            }
		        });
		        this.mensaje += '%0A%0A';
		        this.mensaje += `*Dirección de origen:*%20${direccion_pedido.replace("Colombia","")}`;
		        this.mensaje += '%0A';
		        this.mensaje += `*Dirección de destino:*%20${direccion_destino.replace("Colombia","")}`; 
		        this.mensaje += '%0A';
		        this.mensaje += `*Distancia del recorrido:*%20${this.distance}Km%20aproximadamente`;
		        this.mensaje += '%0A';
		        if (this.valor_domicilio > 0) {
		        	this.mensaje += `*Domicilio%3A%20%24%20${new Intl.NumberFormat("de-DE").format(this.valor_domicilio)}*`;
		        }else{
		        	this.mensaje += `El valor del domicilio será confirmado en un momento de acuerdo a la dirección`;
		        }
		        if (this.form.aditional_info) {
		        	this.mensaje += '%0A';
		        	this.mensaje += `*Observaciones adicionales:*%20${this.form.aditional_info}`;
		        }		        
		        this.mensaje += '%0A%0A';
      			this.mensaje += `Gracias.`;
		        location.href = this.mensaje;
			},
			saveBD(){
            	let product = this.form;
            	var form = {};
            	var _self = this;
            	console.log(this.user_name, this.user_phone);
            	form["nombre"] = this.user_name;
            	form["telefono"] = this.user_phone;
            	form["id_companie"] = this.companie_id;
            	form["latitud"] = this.latitud_delivery;
            	form["longitud"] = this.longitud_delivery;
            	form["id_type_service"] = product.id_type_service;
            	form["total"] = this.valor_domicilio;
            	form["id_point"] = this.id_point;
            	form["new_mensajeria"] = true;
            	form["observation"] = product.aditional_info;
            	form["origin_address"] = product.origin_address;
            	form["destiny_address"] = product.destiny_address;
            	form["id_product"] = product.id_product;
            	form["double_service"] = product.double_service;
            	form["os"] = this.nameOS;
            	axios.post('https://back.vinapp.co/api/order/save-order-mensajeria',form)
			    .then(res => {
			    	if(res.data.status == 200)_self.sendWhatsApp();
			    })
			    .catch(err => {
			        console.log(err);      
			    });
            }
		},
		mounted(){
			console.log(this.companie_id);
			console.log(this.form.double_service)
			if (this.form.double_service) {
				this.distance = this.form.distance * 2;
				this.distance = this.distance.toFixed(1);
				console.log(this.distance);
			}else{
				this.distance = this.form.distance.toFixed(1);
			}
			this.getListTaxes();
		}
	}
</script>